// Exibição das horas do cálculo de ponto (funcionarioPontoCalculos). O servidor
// grava as horas em decimal (8,5 = 8h30); com a parametrização
// CALCULOPONTOHORASEMHORADECIMALTELA ativa no inquilino, a tela, as planilhas
// Excel e a validação de horas usam o mesmo valor em horas (08:30).

export const PARAMETRIZACAO_HORAS_EM_HORA =
  "CALCULOPONTOHORASEMHORADECIMALTELA";

export function horasEmHoraNaTela(state) {
  const parametrizacoes = state?.inquilino?.parametrizacoes;
  return (
    Array.isArray(parametrizacoes) &&
    parametrizacoes.some(
      (item) => item?.tipo === PARAMETRIZACAO_HORAS_EM_HORA && item.ativo
    )
  );
}

// Arredonda para o minuto e mantém o sinal: -1,25 vira -01:15.
export function formatarHorasDecimais(valor) {
  const numero = Number(valor) || 0;
  const minutos = Math.round(Math.abs(numero) * 60);
  const sinal = numero < 0 && minutos > 0 ? "-" : "";
  const horas = Math.floor(minutos / 60);
  const resto = minutos % 60;
  return `${sinal}${String(horas).padStart(2, "0")}:${String(resto).padStart(
    2,
    "0"
  )}`;
}

// Mesmo resultado do filtro numeroTresCasasDecimais quando a parametrização
// está inativa.
export function formatarHorasPonto(valor, emHora) {
  if (emHora) {
    return formatarHorasDecimais(valor);
  }
  return Number(valor || 0).toLocaleString("pt-br");
}

// Célula do SheetJS com a fração do dia no formato [hh]:mm, que exibe 08:30 e
// continua somável no Excel. O Excel não exibe tempo negativo; nesse caso a
// célula recebe o texto (-01:15).
export function celulaHorasExcel(valor) {
  const numero = Number(valor) || 0;
  const minutos = Math.round(Math.abs(numero) * 60);
  if (numero < 0 && minutos > 0) {
    return { t: "s", v: formatarHorasDecimais(numero) };
  }
  return { t: "n", v: minutos / 1440, z: "[hh]:mm" };
}

// Aceita 8, 8:30, 125:45 e -1:15; devolve as horas em decimal ou null quando
// o texto não está no formato.
export function horasTextoParaDecimal(texto) {
  const partes = /^(-)?(\d{1,4})(?::([0-5]\d))?$/.exec(
    String(texto ?? "").trim()
  );
  if (!partes) {
    return null;
  }
  const horas = Number(partes[2]) + Number(partes[3] || 0) / 60;
  return partes[1] ? -horas : horas;
}

// Quantidade de horas informada em HH:MM no afastamento. Além do formato da
// validação de horas, 3 ou 4 dígitos sem separador são lidos como HHMM (830 =
// 08:30, como no campo de horário) e "h" vale como separador (8h30, 8h).
export function horasInformadasParaDecimal(texto) {
  const normalizado = String(texto ?? "")
    .trim()
    .replace(/^(-?\d{1,4})h(\d{2})?$/i, (_, horas, minutos) =>
      minutos ? `${horas}:${minutos}` : horas
    )
    .replace(/^(-?)(\d{1,2})(\d{2})$/, "$1$2:$3");
  return horasTextoParaDecimal(normalizado);
}

// Quantidade de horas informada em decimal: aceita vírgula ou ponto (8,5 e
// 8.5) e devolve o número ou null quando o texto não está no formato.
export function horasDecimaisTextoParaNumero(texto) {
  const partes = /^(-)?(\d{0,4})(?:[.,](\d{0,6}))?$/.exec(
    String(texto ?? "").trim()
  );
  if (!partes || (!partes[2] && !partes[3])) {
    return null;
  }
  const horas = Number(`${partes[2] || 0}.${partes[3] || 0}`);
  return partes[1] && horas ? -horas : horas;
}

// Horas em decimal no separador do idioma (8,5 em pt-BR, 8.5 em en-US), sem
// separador de milhar; vazio quando não há valor.
export function formatarHorasDecimaisTexto(valor, idioma = "pt-BR") {
  if (valor === null || valor === undefined || valor === "") {
    return "";
  }
  const numero = Number(valor);
  if (Number.isNaN(numero)) {
    return "";
  }
  return numero.toLocaleString(idioma, {
    useGrouping: false,
    maximumFractionDigits: 4,
  });
}
